export const SET_ALL_GRAPHICS = 'SET_ALL_GRAPHICS';
export const SET_GRAPHICS_SECTIONS = 'SET_GRAPHICS_SECTIONS';
export const SET_SELFIE_MEDIA = 'SET_SELFIE_MEDIA';
export const SET_GRAPHICS_SECTION = 'SET_GRAPHICS_SECTION';
export const SET_GRAPHICS_SELECTED_IND = 'SET_GRAPHICS_SELECTED_IND';
export const SET_MULTISELECT_VALUE = 'SET_MULTISELECT_VALUE';
export const ADD_GRAPHICS_ITEM = 'ADD_GRAPHICS_ITEM';
export const DELETE_GRAPHICS_ITEM = 'DELETE_GRAPHICS_ITEM';
export const SET_GRAPHICS_ERROR = 'SET_GRAPHICS_ERROR';
export const UPLOAD_GRAPHICS_FILE = 'UPLOAD_GRAPHICS_FILE';
export const UPLOAD_GRAPHICS_FILE_DONE = 'UPLOAD_GRAPHICS_FILE_DONE';
export const SET_CUSTOM_ICON_FILE = 'SET_CUSTOM_ICON_FILE';
export const SET_CUSTOM_ICON_ERROR = 'SET_CUSTOM_ICON_ERROR';
export const UPLOAD_CUSTOM_ICON_START = 'UPLOAD_CUSTOM_ICON_START';
export const UPLOAD_CUSTOM_ICON_DONE = 'UPLOAD_CUSTOM_ICON_DONE';
export const SET_WATERMARKS = 'SET_WATERMARKS';
